export const dayRemarkList = {
  zh: [
    {
      label: "",
      content: "以下用10月10日08:00:00 ~ 09:00:00为例"
    },
    {
      label: "按日：",
      content: "以小时为区间"
    },
    {
      label: "流量计累积：",
      content: "9点的流量计累积量 - 8点的流量计累积量"
    },
    {
      label: "用电量：",
      content: "9点的电表累积量 - 8点的电表累积量"
    },
    {
      label: "单耗：",
      content: "(9点的电表累积量 - 8点的电表累积量) / (9点的流量计累积量 - 8点的流量计累积量)"
    },
    {
      label: "比功率：",
      content: "((9点的电表累积量 - 8点的电表累积量) / 1小时) / ((9点的流量计累积量 - 8点的流量计累积量) / 60分钟)"
    },
    {
      label: "区间流量起始值：",
      content: "8点的流量计累积量"
    },
    {
      label: "区间流量截止值：",
      content: "9点的流量计累积量"
    },
    {
      label: "区间用电量起始值：",
      content: "8点的电表累积量"
    },
    {
      label: "区间用电量截止值：",
      content: "9点的电表累积量"
    }
  ],
  en: [
    {
      label: "",
      content: "The following uses 08:00:00 to 09:00:00 on October 10 as an example"
    },
    {
      label: "Daily: ",
      content: "By the hour"
    },
    {
      label: "Gas Consumption: ",
      content: "Flow meter accumulation at 9 o'clock - Flow meter accumulation at 8 o'clock"
    },
    {
      label: "Power Consumption: ",
      content: "Electricity meter accumulation at 9 o'clock - Electricity meter accumulation at 8 o'clock"
    },
    {
      label: "Average Consumption: ",
      content: "(Electricity meter accumulation at 9 o'clock - Electricity meter accumulation at 8 o'clock) / (Flow meter accumulation at 9 o'clock - Flow meter accumulation at 8 o'clock)"
    },
    {
      label: "Specific Power: ",
      content: "((Electricity meter accumulation at 9 o'clock - Electricity meter accumulation at 8 o'clock) / 1 hour) / ((Flow meter accumulation at 9 o'clock - Flow meter accumulation at 8 o'clock) / 60 minutes)"
    },
    {
      label: "Gas Consumption Start: ",
      content: "Flow meter accumulation at 8 o'clock"
    },
    {
      label: "Gas Consumption End: ",
      content: "Flow meter accumulation at 9 o'clock"
    },
    {
      label: "Power Consumption Start: ",
      content: "Electricity meter accumulation at 8 o'clock"
    },
    {
      label: "Power Consumption End: ",
      content: "Electricity meter accumulation at 9 o'clock"
    }
  ]
}

export const monthRemarkList = {
  zh: [
    {
      label: "",
      content: "以下用10月10日为例"
    },
    {
      label: '按月：',
      content: '以天为区间'
    },
    {
      label: "流量计累积：",
      content: "10月10日的流量计累积量 - 10月9日的流量计累积量"
    },
    {
      label: "用电量：",
      content: "10月10日的电表累积量 - 10月9日的电表累积量"
    },
    {
      label: "单耗：",
      content: "(10月10日的电表累积量 - 10月9日的电表累积量) / (10月10日的流量计累积量 - 10月9日的流量计累积量)"
    },
    {
      label: "比功率：",
      content: "((10月10日的电表累积量 - 10月9日的电表累积量) / 24小时) / ((10月10日的流量计累积量 - 10月9日的流量计累积量) / 24小时 / 60分钟)"
    },
    {
      label: "区间流量起始值：",
      content: "10月9日的流量计累积量"
    },
    {
      label: "区间流量截止值：",
      content: "10月10日的流量计累积量"
    },
    {
      label: "区间用电量起始值：",
      content: "10月9日的电表累积量"
    },
    {
      label: "区间用电量截止值：",
      content: "10月10日的电表累积量"
    }
  ],
  en: [
    {
      label: "",
      content: "The following uses October 10 as an example"
    },
    {
      label: 'Monthly: ',
      content: 'By the day'
    },
    {
      label: "Gas Consumption: ",
      content: "Flow meter accumulation on October 10 - Flow meter accumulation on October 9"
    },
    {
      label: "Power Consumption: ",
      content: "Electricity meter accumulation on October 10 - Electricity meter accumulation on October 9"
    },
    {
      label: "Average Consumption: ",
      content: "(Electricity meter accumulation on October 10 - Electricity meter accumulation on October 9) / (Flow meter accumulation on October 10 - Flow meter accumulation on October 9)"
    },
    {
      label: "Specific Power: ",
      content: "((Electricity meter accumulation on October 10 - Electricity meter accumulation on October 9) / 24 hours) / ((Flow meter accumulation on October 10 - Flow meter accumulation on October 9) / 24 hours / 60 minutes)"
    },
    {
      label: "Gas Consumption Start: ",
      content: "Flow meter accumulation on October 9"
    },
    {
      label: "Gas Consumption End: ",
      content: "Flow meter accumulation on October 10"
    },
    {
      label: "Power Consumption Start: ",
      content: "Electricity meter accumulation on October 9"
    },
    {
      label: "Power Consumption End: ",
      content: "Electricity meter accumulation on October 10"
    }
  ]
}

export const yearRemarkList = {
  zh: [
    {
      label: "",
      content: "以下用2024年10月为例"
    },
    {
      label: '按年：',
      content: '以月为区间'
    },
    {
      label: "流量计累积：",
      content: "10月的流量计累积量 - 9月的流量计累积量"
    },
    {
      label: "用电量：",
      content: "10月的电表累积量 - 9月的电表累积量"
    },
    {
      label: "单耗：",
      content: "(10月的电表累积量 - 9月的电表累积量) / (10月的流量计累积量 - 9月的流量计累积量)"
    },
    {
      label: "比功率：",
      content: "((10月的电表累积量 - 9月的电表累积量) / 31天 / 24小时) / ((10月的流量计累积量 - 9月的流量计累积量) / 31天 / 24小时 / 60分钟)"
    },
    {
      label: "区间流量起始值：",
      content: "9月的流量计累积量"
    },
    {
      label: "区间流量截止值：",
      content: "10月的流量计累积量"
    },
    {
      label: "区间用电量起始值：",
      content: "9月的电表累积量"
    },
    {
      label: "区间用电量截止值：",
      content: "10月的电表累积量"
    }
  ],
  en: [
    {
      label: "",
      content: "The following uses October 2024 as an example"
    },
    {
      label: 'Yearly: ',
      content: 'By the year'
    },
    {
      label: "Gas Consumption: ",
      content: "Flow meter accumulation on October 31 - Flow meter accumulation on September 30"
    },
    {
      label: "Power Consumption: ",
      content: "Electricity meter accumulation on October 31 - Electricity meter accumulation on September 30"
    },
    {
      label: "Average Consumption: ",
      content: "(Electricity meter accumulation on October 31 - Electricity meter accumulation on September 30) / (Flow meter accumulation on October 31 - Flow meter accumulation on September 30)"
    },
    {
      label: "Specific Power: ",
      content: "((Electricity meter accumulation on October 31 - Electricity meter accumulation on September 30) / 31 days / 24 hours) / ((Flow meter accumulation on October 31 - Flow meter accumulation on September 30) / 31 days / 24 hours / 60 minutes)"
    },
    {
      label: "Gas Consumption Start: ",
      content: "Flow meter accumulation on September 30"
    },
    {
      label: "Gas Consumption End: ",
      content: "Flow meter accumulation on October 31"
    },
    {
      label: "Power Consumption Start: ",
      content: "Electricity meter accumulation on September 30"
    },
    {
      label: "Power Consumption End: ",
      content: "Electricity meter accumulation on October 31"
    }
  ]
}